import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography} from "@material-ui/core";
import { IoMdCloseCircleOutline } from "react-icons/io";

import { API_URL } from "../../../constants/api";
import { apiPost, apiPut, apiRequest } from "../../../utils/api_service";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { PaperComponent, getToolTipText } from "../../../utils/helper";
import "../configuration.less";
import { validateInput } from "../../../utils/validations";
import { TOOLTIP_LABEL, routingValidation } from "../../../constants/appConstants";
import InputLabelWithToolTip from "../../common/InputLabelToolTip/InputLabelWithToolTip";
import VirtualizedAutocomplete from "../../common/VirtualizedAutocomplete/VirtualizedAutocomplete";
import sortBy from "lodash/sortBy";

class AddRoutingAndNotification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      routingId: 0,
      distributionGroup: "",
      selectedDataCenterId: "",
      selectedCategoryId: "",
      selectedModuleId: "",
      selectedDistributionId: "",
      dataCenterMasterData: props.dataCenterMasterData,
      categoryMasterData: props.categoryMasterData,
      moduleMasterData: props.moduleMasterData,
      distributionGroupMasterData: props.distributionGroupMasterData
    };
  }

  componentDidMount() {
  }

  /**
   * get props on component based on routing id
   * @param {*} newProps 
   */
  componentWillReceiveProps(newProps) {
    if (newProps.routingId != this.state.routingId && newProps.routingId > 0) {
      this.getRoutingDetails(newProps.routingId);
    }
    this.setState({ routingId: newProps.routingId });
  }

  /**
   * get routing data by routing id
   * @param {*} routing 
   */
  getRoutingDetails = routingId => {
    const params = {
        routingId: routingId
    };
    apiRequest({ url: API_URL.tenant.GetTenantById, params }).then(
      ({ data: routingData }) => {
        if (routingData) {       

          this.setState({
            distributionGroup: routingData.distributionGroup,
            selectedDataCenterId: routingData.selectedDataCenterId,
            selectedCategoryId: routingData.selectedCategoryId,
            selectedModuleId: routingData.selectedModuleId
          });
        } else {
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
        }
      }
    );
  };

  /**
   * call on submit button
   * @param {*} isAddRecipient 
   */
  onSubmit = (isAddRecipient = false) => {
    const {
      routingId,
      distributionGroup,
      selectedDataCenterId,
      selectedCategoryId,
      selectedModuleId
    } = this.state;

    if (routingId > 0) {
      this.updateRouting({
        routingId,
        selectedDataCenterId,
        selectedCategoryId,
        selectedModuleId,
        status: 1,
        distributionGroup

      });
    } else {
      this.addRouting(
        {
            routingId,
            distributionGroup,
            selectedDataCenterId,
            selectedCategoryId,
            selectedModuleId,
            isAddRecipient
        }
      );
    }
  };

  /**
   * add tenant api to save tenant data
   * @param {*} params 
   * @param {*} isAddContact 
   */
  addRouting = (params, isAddRecipient = false) => {
    this.setState({ isCloseSaveConfirm: false });
    apiPost({
      url: API_URL.tenant.AddTenant,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (!success || response?.success == 0) {
        ShowToast(response.message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success == true) {
        ShowToast("Routing added Successfully", toastType.SUCCESS, 5000, 200);
        if (response.data.routingId && isAddRecipient) {
          this.props.history.push({
            pathname: "/tenantContact",
            aboutProps: {
              routingId: response.data.routingId,
              distributionGroup: response.data.distributionGroup,
              selectedDataCenterId: response.data.selectedDataCenterId,
              isOpenDefaultAdd: true,
              isActiveTenant: true
            }
          });
        } else {
          this.props.onSave(true);
        }
      } else {
        this.props.onSave(false);
      }
    });
  };

  /**
   * update tenant api to update tenant data
   * @param {*} params 
   */
  updateRouting = params => {
    apiPut({
      url: API_URL.tenant.UpdateTenant,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (!success || response?.success == 0) {
        ShowToast(response.message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success == true) {
        ShowToast("Routing Updated Successfully", toastType.SUCCESS, 5000, 200);
        this.props.onSave(true);
      } else {
        this.props.onSave(false);
      }
    });
  };

  /**
   * call on submit confirm button
   * @returns 
   */
  onSubmitConfirm = () => {
    const {
        routingId,
        distributionGroup,
        selectedDataCenterId,
        selectedCategoryId,
        selectedModuleId,
    } = this.state;
    const routingBody = {
        routingId,
        distributionGroup,
        propertyId: selectedDataCenterId,
        categoryId: selectedCategoryId,
        moduleId: selectedModuleId,
    };

    if (validateInput(routingBody, routingValidation)) {
      if (routingId > 0) {
        this.onSubmit();
      } else {
        this.setState({ isCloseSaveConfirm: true });
      }
    }
  };

  /**
   * call on textBox control
   * @param {*} i 
   * @param {*} e 
   */
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**
   * call on dropdown select value
   * @param {*} name 
   * @param {*} id 
   */
  onPropertySelect = (name, id )=> {
    this.setState({ [name]: id });
  };


  render() {
    const {
            dataCenterMasterData,
            moduleMasterData,
            categoryMasterData,
            distributionGroupMasterData,
            selectedModuleId,
            selectedDataCenterId,
            selectedCategoryId,
            selectedDistributionId,
            isCloseSaveConfirm
          } = this.state;

    const { 
            isOpen, 
            onClose, 
            routingId, 
            toolTipData            
          } = this.props

    return (
      <div>
        <Dialog
          open={isOpen || false}
          onClose={() => onClose(false)}
          PaperComponent={PaperComponent}
          fullWidth
          maxWidth={"md"}
          className={"add-Update-distribution-group"}
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar> 
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {routingId > 0 ? "Edit Distribution Group" : "Add Distribution Group"}
              </Typography>
                <IconButton
                    title={"Close"}
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => onClose(false)}
                    aria-label={"close"}
                    className={"white-button"}
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent>
            <Box
              component={"form"}
              border={0}
              borderColor={"grey.500"}
              borderRadius={1}
              noValidate
              autoComplete={"off"}
              className={"routingNotificationTable"}
            >
              <div className={"row"}>
                <div className={"col-xs-4"}>
                  <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"distribution-group-list"}
                      isRequired
                      labelHeading={TOOLTIP_LABEL.DISTRIBUTION_GROUP}
                      toolTip={getToolTipText(toolTipData, TOOLTIP_LABEL.DISTRIBUTION_GROUP)}
                  />
                      <Select
                        fullWidth
                        labelId={"distribution-group-list"}
                        id={"distribution-group-list-select"}
                        label={TOOLTIP_LABEL.DISTRIBUTION_GROUP}
                        value={selectedDistributionId}
                        onChange={e => this.onPropertySelect("selectedDistributionId", e.target.value)}                    
                      >
                        {(distributionGroupMasterData || []).map((item, index) => (
                          <MenuItem
                            key={"module" + index}
                            value={item.id}
                          >
                            {item.value}
                          </MenuItem>
                        ))}
                      </Select>
                </div>
                <div className={"col-xs-4"}>
                  <FormControl fullWidth className={"dropdown-select"}>
                    <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"module-list"}
                      isRequired
                      labelHeading={TOOLTIP_LABEL.MODULE}
                      toolTip={getToolTipText(toolTipData, TOOLTIP_LABEL.MODULE)}
                    />
                    <Select
                      fullWidth
                      labelId={"module-list"}
                      id={"module-list-select"}
                      label={TOOLTIP_LABEL.MODULE}
                      value={selectedModuleId}
                      onChange={e => this.onPropertySelect("selectedModuleId", e.target.value)}                    
                    >
                      {(moduleMasterData || []).map((item, index) => (
                        <MenuItem
                          key={"distributionGroup" + index}
                          value={item.id}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={"col-xs-4"}>
                  <FormControl fullWidth className={"dropdown-select"}>
                      <VirtualizedAutocomplete
                        key={"data-center-id"}
                        parentKey={"data-center-id"}
                        isSelectAll={false}
                        header={"Data Center"}
                        optionsList={sortBy(dataCenterMasterData, (x) => x.value)}
                        selectedIds={selectedDataCenterId || []}
                        minWidth={"300px"}
                      />
                  </FormControl>
                </div>
              </div>
              <div className={"row bottom-xs"}>
                <div className={"col-xs-4"}>
                  <FormControl fullWidth className={"dropdown-select"}>
                    <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"category-list"}
                      isRequired
                      labelHeading={TOOLTIP_LABEL.CATEGORY}
                      toolTip={getToolTipText(toolTipData, TOOLTIP_LABEL.CATEGORY)}
                    />
                    <Select
                      fullWidth
                      labelId={"category-list"}
                      id={"category-list-select"}
                      label={TOOLTIP_LABEL.CATEGORY}
                      value={selectedCategoryId}
                      onChange={e => this.onPropertySelect("selectedCategoryId", e.target.value)}                    
                    >
                      {(categoryMasterData || []).map((item, index) => (
                        <MenuItem
                          key={"category" + index}
                          value={item.id}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Box>
          </DialogContent>
          <DialogActions style={{ paddingRight: "24px" }}>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => onClose(false)}
            >
              {"Close\r"}
            </Button>
            <Button
              style={{ marginRight: "8px" }}
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmitConfirm()}
            >
              {"Save\r"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isCloseSaveConfirm || false}
          onClose={() => this.props.onClose(false)}
          PaperComponent={PaperComponent}
          // fullWidth
          maxWidth={"md"}
        >
          <DialogContent>
            <FormControlLabel
              control={<div />}
              label={"Do you want to add a contact?"}
            />
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmit(false)}
            >
              {"No\r"}
            </Button>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmit(true)}
            >
              {"Yes\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddRoutingAndNotification;
